import { useLanguage } from "@/i18n/LanguageContext";
import { useEffect, useState } from "react";

const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();
  const [scrolledPastHero, setScrolledPastHero] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolledPastHero(window.scrollY > window.innerHeight * 0.8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="fixed right-6 z-50 flex gap-2 transition-[top] duration-500 ease-out"
      style={{ top: scrolledPastHero ? "1.5rem" : "5rem" }}
    >
      <button
        onClick={() => setLang("pl")}
        className={`w-7 h-7 md:w-9 md:h-9 rounded-full overflow-hidden border-2 transition-all duration-300 cursor-pointer ${
          lang === "pl"
            ? "border-accent scale-110 shadow-lg"
            : "border-transparent opacity-60 hover:opacity-100 hover:scale-105"
        }`}
        aria-label="Polski"
        title="Polski"
      >
        <svg viewBox="0 0 640 480" className="w-full h-full">
          <rect width="640" height="240" fill="#fff" />
          <rect y="240" width="640" height="240" fill="#dc143c" />
        </svg>
      </button>
      <button
        onClick={() => setLang("en")}
        className={`w-7 h-7 md:w-9 md:h-9 rounded-full overflow-hidden border-2 transition-all duration-300 cursor-pointer ${
          lang === "en"
            ? "border-accent scale-110 shadow-lg"
            : "border-transparent opacity-60 hover:opacity-100 hover:scale-105"
        }`}
        aria-label="English"
        title="English"
      >
        <svg viewBox="0 0 640 480" className="w-full h-full">
          <rect width="640" height="480" fill="#012169" />
          <path d="M75 0l244 181L562 0h78v62L400 241l240 178v61h-80L320 302 81 480H0v-60l239-178L0 64V0h75z" fill="#fff" />
          <path d="M424 281l216 159v40L369 281h55zm-184 20l6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z" fill="#C8102E" />
          <path d="M241 0v480h160V0H241zM0 160v160h640V160H0z" fill="#fff" />
          <path d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z" fill="#C8102E" />
        </svg>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
